/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // FAQ accordion

  function initFaq(root) {
    if (!root || root.__faqInited) return;
    root.__faqInited = true;

    var singleOpen = (root.getAttribute('data-faq-single-open') === 'true');
    var openFirst  = (root.getAttribute('data-faq-open-first') === 'true');

    var items = Array.from(root.querySelectorAll('.faq__item'));

    function openItem(item) {
      if (!item || item.classList.contains('is-open')) return;
      var panel = item.querySelector('.faq__a');
      var btn   = item.querySelector('.faq__q');
      if (!panel || !btn) return;

      if (singleOpen) {
        items.forEach(function (it) { if (it !== item) closeItem(it); });
      }

      btn.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');

      panel.style.height = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', onEnd);
      });
    }

    function closeItem(item) {
      if (!item || !item.classList.contains('is-open')) return;
      var panel = item.querySelector('.faq__a');
      var btn   = item.querySelector('.faq__q');
      if (!panel || !btn) return;

      btn.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');

      panel.style.height = panel.scrollHeight + 'px';
      panel.offsetHeight;
      panel.style.height = '0px';
    }

    items.forEach(function (item) {
      var panel = item.querySelector('.faq__a');
      if (panel) panel.style.height = '0px';

      item.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        item.classList.contains('is-open') ? closeItem(item) : openItem(item);
      });

      var btn = item.querySelector('.faq__q');
      if (btn) {
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            item.classList.contains('is-open') ? closeItem(item) : openItem(item);
          }
        });
      }
    });

    if (openFirst && items[0]) openItem(items[0]);
  }

  document.querySelectorAll('[data-faq-root]').forEach(initFaq);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-faq-root]');
    if (root) initFaq(root);
  });
// countdown timer 

  var countdowns = document.querySelectorAll('[data-countdown]');
  
  if (countdowns.length) {
    countdowns.forEach(function(root) {
      var mode = root.getAttribute('data-mode') || 'midnight';

      if (mode === 'inventory') {
        return;
      }

      var target;

      if (mode === 'fixed') {
        var raw = root.getAttribute('data-target-time');
        if (!raw) return;

        var normalized = raw.replace(' ', 'T');
        target = new Date(normalized);

        if (isNaN(target.getTime())) {
          console.warn('Countdown: invalid date', raw);
          return;
        }
      } else if (mode === 'midnight') {
        var now = new Date();
        target = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() + 1,
          0, 0, 0, 0
        );
      } else {
        return;
      }

      var elHours   = root.querySelector('.js-countdown-hours');
      var elMinutes = root.querySelector('.js-countdown-minutes');
      var elSeconds = root.querySelector('.js-countdown-seconds');

      if (!elHours || !elMinutes || !elSeconds) return;

      function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      }

      function tick() {
        var now = new Date();
        var diff = target - now;

        if (diff <= 0) {
          elHours.textContent   = '00';
          elMinutes.textContent = '00';
          elSeconds.textContent = '00';
          root.classList.add('dev-countdown--ended');
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        elHours.textContent   = pad(hours);
        elMinutes.textContent = pad(minutes);
        elSeconds.textContent = pad(seconds);

        setTimeout(tick, 1000);
      }

      tick();
    });
  }

  // fix header background on desktop

  const header = document.querySelector('[data-site-header]');
  const headerBg = document.querySelector('[data-header-background]');
  const headerNavItems = header ? header.querySelectorAll('[data-nav-item]') : [];

  if (header && headerBg) {
    const baseHeaderHeight = header.offsetHeight;

    function setBgHeightToHeader() {
      headerBg.style.setProperty('--header-background-height', `${baseHeaderHeight}px`);
    }

    function setBgHeightForItem(item) {
      const dropdown = item.querySelector('.header__dropdown__wrapper');
      const hasDropdown = dropdown && dropdown.children.length > 0;

      if (hasDropdown) {
        const dropdownHeight = dropdown.scrollHeight || dropdown.offsetHeight || 0;
        headerBg.style.setProperty(
          '--header-background-height',
          `${baseHeaderHeight + dropdownHeight}px`
        );
      } else {
        setBgHeightToHeader();
      }
    }

    if (headerNavItems.length) {
      headerNavItems.forEach((item) => {
        item.addEventListener('mouseenter', () => setBgHeightForItem(item));
        item.addEventListener('focusin', () => setBgHeightForItem(item));
        item.addEventListener('mouseleave', setBgHeightToHeader);
        item.addEventListener('focusout', setBgHeightToHeader);
      });
    } else {
      // Fallback if no items found
      header.addEventListener('mouseenter', setBgHeightToHeader);
      header.addEventListener('mousemove', setBgHeightToHeader);
      header.addEventListener('mouseleave', () => {
        headerBg.style.setProperty('--header-background-height', '0px');
      });
    }
  }

  // cart drawer phone validation + persistence
  function initCartExtraFormValidator(root) {
    if (!root) return;

    var form = root.closest('form');
    if (!form || form.dataset.cartExtraBound === '1') return;

    form.dataset.cartExtraBound = '1';

    var phoneInput = root.querySelector('input[name="attributes[phone]"]');
    var promoInput = root.querySelector('input[name="attributes[promo_code]"]');
    var errorBox  = root.querySelector('[data-cart-extra-error]');
    var checkoutButton = form.querySelector('button[name="checkout"]');
    var phoneDisableFlag = 'data-phone-disabled';

    function showError(message) {
      if (!errorBox) {
        alert(message);
        return;
      }
      errorBox.textContent = message;
      errorBox.style.display = 'block';
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.style.display = 'none';
    }

    if (phoneInput && checkoutButton) {
      phoneInput.addEventListener('input', function () {
        if (checkoutButton.getAttribute(phoneDisableFlag) === 'true') {
          checkoutButton.removeAttribute('disabled');
          checkoutButton.removeAttribute(phoneDisableFlag);
        }
        clearError();
      });
    }

    function validatePhone() {
      if (!phoneInput) return {valid: true};

      var required = phoneInput.dataset.phoneRequired !== 'false';
      var value = phoneInput.value.trim();

      if (required && !value) {
        return {valid: false, message: 'Please enter your phone number'};
      }

      if (!required && !value) {
        return {valid: true};
      }

      var normalized = value.replace(/\s+/g, '');
      var pattern = /^\+?[0-9]{10,15}$/;

      if (!pattern.test(normalized)) {
        return {valid: false, message: 'Please enter a valid phone number (e.g. +1 555 123 4567)'};
      }

      return {valid: true};
    }

    function persistAttributes(event) {
      var attributes = {};
      if (phoneInput) {
        attributes.phone = phoneInput.value.trim();
      }
      if (promoInput) {
        attributes.promo_code = promoInput.value.trim();
      }

      if (!Object.keys(attributes).length) return;

      event.preventDefault();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      })
        .catch(function () { /* silent */ })
        .finally(function () {
          form.submit();
        });
    }

    form.addEventListener('submit', function (event) {
      clearError();

      var validation = validatePhone();
      if (!validation.valid) {
        event.preventDefault();
        event.stopPropagation();
        showError(validation.message);
        if (phoneInput) phoneInput.focus();
        if (checkoutButton) {
          checkoutButton.setAttribute('disabled', 'disabled');
          checkoutButton.setAttribute(phoneDisableFlag, 'true');
        }
        return;
      }

      if (checkoutButton) {
        checkoutButton.removeAttribute('disabled');
        checkoutButton.removeAttribute(phoneDisableFlag);
      }

      persistAttributes(event);
    });
  }

  function bindCartExtraForms() {
    document
      .querySelectorAll('[data-cart-extra-form]')
      .forEach(initCartExtraFormValidator);
  }

  document.addEventListener('DOMContentLoaded', bindCartExtraForms);
  document.addEventListener('theme:cart:added', bindCartExtraForms);
  document.addEventListener('theme:cart:loaded', bindCartExtraForms);
  document.addEventListener('theme:cart:update', bindCartExtraForms);
  bindCartExtraForms();

  // disable first link in megamenu

  document.addEventListener('click', function(e) {
    const link = e.target.closest('.mobile-navlink--level-2');
    if (!link) return;

    const parentItem = link.closest('.mobile-menu__item--level-2');
    const subMenu = parentItem.querySelector('.mobile-nav__sub-sublist');

    if (!subMenu) return;

    e.preventDefault();

    const trigger = parentItem.querySelector('[data-collapsible-trigger]');

    if (trigger) {
      trigger.click();
    }
  })

  // fix header background height
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const bg = document.querySelector('[data-header-background]');
  if (!header || !bg) return;

  const items = header.querySelectorAll('[data-nav-item]');
  const updateBg = (el) => {
    const dropdown = el.querySelector('.header__dropdown__wrapper');
    const dropdownH = dropdown ? dropdown.scrollHeight : 0;
    const headerH = header.offsetHeight || 0;
    bg.style.setProperty('--header-background-height', `${headerH + dropdownH}px`);
  };

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => updateBg(item));
    item.addEventListener('focusin', () => updateBg(item));
  });
});

// Keep cart recommendations hidden when the cart is empty without reloading the page
document.addEventListener('DOMContentLoaded', () => {
  const recSelector = '[data-cart-recommendations]';
  const itemsHolderSelector = '[data-items-holder]';
  const itemSelector = '[data-cart-item]';

  const updateRecommendations = () => {
    const rec = document.querySelector(recSelector);
    const itemsHolder = document.querySelector(itemsHolderSelector);
    if (!rec || !itemsHolder) return;

    const hasItems = itemsHolder.querySelectorAll(itemSelector).length > 0;
    rec.classList.toggle('hidden', !hasItems);
    rec.style.display = hasItems ? '' : 'none';
  };

  // Initial check
  updateRecommendations();

// Update after cart drawer renders/updates
document.addEventListener('theme:cart:added', updateRecommendations);
document.addEventListener('theme:cart:loaded', updateRecommendations);
});

// Brand filter helpers
(() => {
  const getListMaxHeight = () => {
    const viewportHeight = Math.max(window.visualViewport?.height || window.innerHeight || 0, 0);
    const chromeHeight = window.innerHeight && window.visualViewport ? Math.max(window.innerHeight - window.visualViewport.height, 0) : 0;
    const usableHeight = Math.max(viewportHeight - chromeHeight, 0);

    return Math.max(280, Math.floor(viewportHeight * 0.6));
  };

  const getScrollableParent = (el) => {
    let node = el?.parentElement;
    while (node) {
      const style = window.getComputedStyle(node);
      const canScroll = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
      if (canScroll) return node;
      node = node.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  const setupBrandFilter = (wrapper) => {
    if (!wrapper) return;

    const mainList = wrapper.querySelector('[data-collapsible-content]');
    const extraContainer = wrapper.querySelector('[data-show-more-container]');
    const extraList = extraContainer ? extraContainer.querySelector('ul[data-collapsible-content]') : null;
    const trigger = wrapper.querySelector('[data-show-more-trigger]');
    const actions = wrapper.querySelector('[data-show-more-actions]');

    if (!mainList) return;

    // Merge extra items into main list (only once)
    if (wrapper.dataset.brandListNormalized !== 'true') {
      if (extraList) {
        extraList.querySelectorAll('li').forEach((item) => mainList.appendChild(item));
        extraContainer.style.display = 'none';
      }

      // Remove show more/less UI and keep a single scrollable list
      if (actions) actions.remove();
      if (trigger) trigger.remove();
    }

    // Set fixed scrollable height
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      mainList.style.maxHeight = 'none';
      mainList.style.overflowY = 'visible';
      mainList.style.webkitOverflowScrolling = 'auto';
      mainList.style.paddingBottom = '0';
    } else {
      mainList.style.maxHeight = `${getListMaxHeight()}px`;
      mainList.style.overflowY = 'auto';
      mainList.style.webkitOverflowScrolling = 'touch';
      mainList.style.paddingBottom = 'calc(12px + env(safe-area-inset-bottom, 0px))';
    }

    wrapper.dataset.brandListNormalized = 'true';
  };

  const bindAlphabetNav = (alphabet) => {
    if (!alphabet || alphabet.dataset.brandAlphabetBound === 'true') return;
    alphabet.dataset.brandAlphabetBound = 'true';

    alphabet.addEventListener('click', (event) => {
      const button = event.target.closest('[data-letter-nav]');
      if (!button || button.disabled) return;

      const letter = button.getAttribute('data-letter-nav');
      const wrapper = button.closest('.collection__filter-tags-wrapper');
      if (!wrapper) return;

      const items = Array.from(wrapper.querySelectorAll('[data-letter]'));
      const targets = items.filter((item) => item.dataset.letter === letter);
      if (!targets.length) return;

      const target = targets[0];
      const scrollContainer = getScrollableParent(target);

      const targetRect = target.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const offset = targetRect.top - containerRect.top + scrollContainer.scrollTop - 12;
      scrollContainer.scrollTo({top: Math.max(offset, 0), behavior: 'smooth'});
    });
  };

  const initBrandFilters = () => {
    document.querySelectorAll('.collection__filter-tags-wrapper--brand').forEach(setupBrandFilter);
    document.querySelectorAll('[data-filter-alphabet]').forEach(bindAlphabetNav);
  };

  document.addEventListener('DOMContentLoaded', initBrandFilters);
  document.addEventListener('theme:filters:init', initBrandFilters);
  window.addEventListener('resize', initBrandFilters);
})();

// Auto-select quantity value on focus so users can overwrite the default easily (works for dynamically added forms)
document.addEventListener('focusin', (event) => {
  const input = event.target.closest('[data-quantity-field]');
  if (!input) return;
  requestAnimationFrame(() => input.select());
});

// Lock quantity inputs to button-only changes
document.addEventListener('DOMContentLoaded', () => {
  const qtyInputs = document.querySelectorAll('[data-quantity-field], [data-dev-qty-input]');
  qtyInputs.forEach((input) => {
    input.readOnly = true;
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('pattern', '[0-9]*');
    input.addEventListener('keydown', (e) => {
      const allowed = ['Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (!allowed.includes(e.key)) {
        e.preventDefault();
      }
    });

    input.addEventListener('change', () => {
      if (!input.value || Number(input.value) < 1) {
        input.value = '1';
      }
    });
  });
});

// Sync quantity between main product form and sticky addbar
document.addEventListener('DOMContentLoaded', () => {
  const mainQty = document.querySelector('[data-product-form] [data-quantity-field]');
  const stickyQty = document.querySelector('[data-dev-sticky-addbar] [data-dev-qty-input]');

  if (!mainQty || !stickyQty) return;

  const clampQty = (value) => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) || parsed < 1 ? 1 : parsed;
  };

  const syncValue = (source, target) => {
    const safe = clampQty(source.value);
    source.value = safe;
    if (target.value !== String(safe)) {
      target.value = safe;
    }
  };

  ['input', 'change'].forEach((evt) => {
    mainQty.addEventListener(evt, () => syncValue(mainQty, stickyQty));
    stickyQty.addEventListener(evt, () => syncValue(stickyQty, mainQty));
  });

  // Also sync after plus/minus clicks which update values programmatically
  document.addEventListener('click', (event) => {
    const isMainBtn = event.target.closest('[data-quantity-plus], [data-quantity-minus]');
    const isStickyBtn = event.target.closest('[data-dev-qty-plus], [data-dev-qty-minus]');

    if (isMainBtn) {
      requestAnimationFrame(() => syncValue(mainQty, stickyQty));
    }

    if (isStickyBtn) {
      requestAnimationFrame(() => syncValue(stickyQty, mainQty));
    }
  });

  syncValue(mainQty, stickyQty);
});

// Refresh parallax measurements after accordion height transitions (accordion-only, debounced)
(() => {
  let parallaxRefreshTimer = null;
  document.addEventListener('transitionend', (event) => {
    if (event.propertyName !== 'height') return;
    const accordion = event.target.closest('[data-section-type="accordions"]');
    if (!accordion) return;

    if (parallaxRefreshTimer) clearTimeout(parallaxRefreshTimer);
    parallaxRefreshTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('theme:parallax:refresh'));
      parallaxRefreshTimer = null;
    }, 250);
  });
})();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Announcement slider: links in slides the slider hides (aria-hidden) must not take focus
document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('[data-announcement-bar] [data-slide]');
  if (!slides.length) return;

  const syncFocus = (slide) => {
    const hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.querySelectorAll('a, button').forEach((el) => {
      if (hidden) el.setAttribute('tabindex', '-1');
      else el.removeAttribute('tabindex');
    });
  };

  const observer = new MutationObserver((mutations) => mutations.forEach((m) => syncFocus(m.target)));
  slides.forEach((slide) => {
    syncFocus(slide);
    observer.observe(slide, {attributes: true, attributeFilter: ['aria-hidden']});
  });
});


// Cart drawer contact/promo form - snippets/dev-cart-form.liquid
(function () {
  // Bound once, on the document: the drawer's HTML (this form included) is re-inserted via
  // innerHTML after cart changes, so nothing can be attached to the form itself. Each handler
  // finds its form and fields at the moment it runs.
  if (window.__devCartFormBound) return;
  window.__devCartFormBound = true;

  const phoneDisableFlag = 'data-phone-disabled';

  function extraForm(target) {
    const form = target && target.closest ? target.closest('form') : null;
    return form && form.querySelector('[data-cart-extra-form]') ? form : null;
  }

  function field(form, selector) {
    return form.querySelector(selector);
  }

  // The code goes on the cart itself (Cart Ajax API `discount`), so the drawer total and
  // checkout both see it. It used to be saved only as a cart attribute, which applied nothing.
  function updateCart(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (res) { return res.json(); });
  }

  function refreshCart() {
    if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
    else window.location.reload();
  }

  function promoNote(form, text, isError) {
    const message = field(form, '[data-cart-promo-message]');
    if (!message) return;
    message.textContent = text;
    message.hidden = false;
    message.classList.toggle('is-error', Boolean(isError));
  }

  function promoApplied(form, code) {
    const message = field(form, '[data-cart-promo-message]');
    if (!message) return;
    message.hidden = false;
    message.classList.remove('is-error');
    message.classList.add('is-success');
    message.textContent = '';
    const label = document.createElement('span');
    label.textContent = '\u2713 ' + code.toUpperCase() + ' applied';
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'cart-extra-promo__remove';
    remove.setAttribute('data-cart-promo-remove', '');
    remove.textContent = 'Remove';
    message.append(label, remove);
  }

  function applyPromo(form) {
    const input = field(form, '[data-cart-promo-input]');
    const button = field(form, '[data-cart-promo-apply]');
    const code = input ? input.value.trim() : '';
    if (!code) {
      promoNote(form, 'Enter a promo code first.', true);
      return;
    }
    if (button) button.disabled = true;
    updateCart({discount: code, attributes: {promo_code: code}})
      .then(function (cart) {
        const match = (cart.discount_codes || []).find(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        });
        if (match && match.applicable) {
          // The drawer only re-renders its line items and totals, not this form, so confirm here.
          promoApplied(form, match.code);
          refreshCart();
          return;
        }
        // Don't carry a code that doesn't apply into checkout.
        return updateCart({discount: ''}).then(function () {
          promoNote(form, '"' + code + '" can\'t be applied to this cart.', true);
        });
      })
      .catch(function () {
        promoNote(form, 'Could not apply the code. Please try again.', true);
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  function showError(form, message) {
    const box = field(form, '[data-cart-extra-error]');
    if (!box) return;
    box.textContent = message;
    box.style.display = 'block';
  }

  function clearError(form) {
    const box = field(form, '[data-cart-extra-error]');
    if (!box) return;
    box.textContent = '';
    box.style.display = 'none';
  }

  function validatePhone(form) {
    const input = field(form, 'input[name="attributes[phone]"]');
    if (!input) return {valid: true};

    const required = input.dataset.phoneRequired !== 'false';
    const value = input.value.trim();

    if (required && !value) {
      return {valid: false, message: 'Please enter your phone number'};
    }
    if (!value) return {valid: true};

    const normalized = value.replace(/\s+/g, '');
    if (!/^\+?[0-9]{10,15}$/.test(normalized)) {
      return {valid: false, message: 'Please enter a valid phone number (e.g. +1 555 123 4567)'};
    }
    return {valid: true};
  }

  document.addEventListener('click', function (event) {
    const form = extraForm(event.target);
    if (!form) return;
    if (event.target.closest('[data-cart-promo-apply]')) {
      event.preventDefault();
      applyPromo(form);
    } else if (event.target.closest('[data-cart-promo-remove]')) {
      event.preventDefault();
      updateCart({discount: '', attributes: {promo_code: ''}}).then(function () {
        const input = field(form, '[data-cart-promo-input]');
        if (input) input.value = '';
        form.querySelectorAll('[data-cart-promo-applied], [data-cart-promo-message]').forEach(function (el) {
          el.hidden = true;
        });
        refreshCart();
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches || !event.target.matches('[data-cart-promo-input]')) return;
    const form = extraForm(event.target);
    if (!form) return;
    event.preventDefault();
    applyPromo(form);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('input[name="attributes[phone]"]')) return;
    const form = extraForm(event.target);
    if (!form) return;
    const button = field(form, 'button[name="checkout"]');
    if (button && button.getAttribute(phoneDisableFlag) === 'true') {
      button.removeAttribute('disabled');
      button.removeAttribute(phoneDisableFlag);
    }
    clearError(form);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.querySelector || !form.querySelector('[data-cart-extra-form]')) return;
    clearError(form);
    const button = field(form, 'button[name="checkout"]');

    const validation = validatePhone(form);
    if (!validation.valid) {
      event.preventDefault();
      event.stopPropagation();
      showError(form, validation.message);
      const phone = field(form, 'input[name="attributes[phone]"]');
      if (phone) phone.focus();
      if (button) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute(phoneDisableFlag, 'true');
      }
      return;
    }
    if (button) {
      button.removeAttribute('disabled');
      button.removeAttribute(phoneDisableFlag);
    }

    // Save phone and promo on the cart before checkout; a code typed but never applied
    // still reaches checkout as a real discount.
    const phone = field(form, 'input[name="attributes[phone]"]');
    const promo = field(form, '[data-cart-promo-input]');
    const attributes = {};
    const body = {};
    if (phone) attributes.phone = phone.value.trim();
    if (promo) {
      attributes.promo_code = promo.value.trim();
      if (attributes.promo_code) body.discount = attributes.promo_code;
    }
    if (!Object.keys(attributes).length) return;
    body.attributes = attributes;

    event.preventDefault();
    // form.submit() drops the clicked button, and without name="checkout" Shopify just
    // updates the cart and shows /cart - carry it over as a hidden field.
    const submitter = event.submitter;
    if (submitter && submitter.name && !form.querySelector('input[type="hidden"][name="' + submitter.name + '"]')) {
      const carry = document.createElement('input');
      carry.type = 'hidden';
      carry.name = submitter.name;
      carry.value = submitter.value || '';
      form.appendChild(carry);
    }
    updateCart(body)
      .catch(function () { /* checkout still goes ahead */ })
      .finally(function () {
        HTMLFormElement.prototype.submit.call(form);
      });
  }, true);
})();

// Cart drawer "Recommended for you": products related to what is in the cart instead of one
// fixed collection. sections/dev-cart-recs.liquid renders them for the newest cart item
// (Shopify's product recommendations), skipping what is already in the cart.
(function () {
  if (window.__devCartRecsBound) return;
  window.__devCartRecsBound = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let lastKey = '';
  let pending = null;

  function refresh() {
    const list = document.querySelector('[data-cart-recommendations-list]');
    if (!list) return;

    fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        const key = cart.items.map(function (item) { return item.product_id; }).join(',');
        if (key === lastKey && list.dataset.devRecsKey === key) return;
        lastKey = key;

        if (pending) pending.abort();
        pending = new AbortController();
        const url = root + 'recommendations/products?product_id=' + cart.items[0].product_id + '&limit=10&section_id=dev-cart-recs';
        return fetch(url, {signal: pending.signal})
          .then(function (res) { return res.text(); })
          .then(function (html) {
            const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dev-cart-recs-result]');
            // Nothing related (or all of it already in the cart): keep what is there.
            if (!result) return;
            const current = document.querySelector('[data-cart-recommendations-list]');
            if (!current) return;
            current.innerHTML = result.innerHTML;
            current.dataset.devRecsKey = key;
          });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:update'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });
})();

// Low-stock colour (snippets/inventory-countdown.liquid): the theme swaps the count on size change,
// this keeps data-dev-stock in step - yellow under the threshold, red under 5.
document.addEventListener('theme:variant:change', function (event) {
  const variant = event && event.detail && event.detail.variant;
  document.querySelectorAll('[data-remaining-wrapper]').forEach(function (wrapper) {
    const json = wrapper.parentElement && wrapper.parentElement.querySelector('[data-product-remaining-json]');
    let remaining;
    try { remaining = variant && json ? JSON.parse(json.textContent)[variant.id] : undefined; } catch (e) { remaining = undefined; }
    // Another product's block (e.g. quick view): not this variant.
    if (remaining === undefined) return;
    const count = parseInt(remaining, 10);
    const max = parseInt(wrapper.dataset.remainingMax, 10);
    if (count > 0 && count < max) {
      wrapper.dataset.devStock = count < 5 ? 'red' : 'yellow';
    } else {
      delete wrapper.dataset.devStock;
    }
  });
});


// Cart drawer: "More payment options" shows the express buttons hidden under Shop Pay -
// snippets/cart-drawer.liquid. Bound on the document: the drawer HTML is re-inserted after
// every cart change (and comes back collapsed).
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-dev-more-pay]');
  if (!link) return;
  const buttons = link.previousElementSibling;
  if (buttons) buttons.classList.remove('dev-pay-collapsed');
  link.remove();
});
